import { Component, input } from '@angular/core';
import { Coupon } from '../../core/models/core/coupon.model';
import { TranslocoDirective } from '@ngneat/transloco';

@Component({
  selector: 'cwo-coupon-conflict',
  standalone: true,
  imports: [
    TranslocoDirective
  ],
  templateUrl: './coupon-conflict.component.html',
  styleUrl: './coupon-conflict.component.scss'
})
export class CouponConflictComponent {
  couponWarning = input.required<Coupon | null>();
}
